import { Query, useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IEventSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const GET_RESPONSE_BY_TOKEN_QUERY_KEY = 'getByTokenQueryKey';

export const useClientGetEventRegistrationResponseByToken = ({
	accessToken,
	enabled = true,
	refetchOnWindowFocus = false,
	retry,
	gcTime,
	refetchInterval,
}: {
	accessToken: string;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	retry?: boolean | number | ((failureCount: number, error: IOperationResultNoValue) => boolean);
	gcTime?: number;
	refetchInterval?: (
		query: Query<IEventSurveyResponse, IOperationResultNoValue, IEventSurveyResponse, string[]>
	) => number | false;
}) => {
	const { apiClient } = useApiClientContext();
	return useQuery({
		enabled,
		gcTime,
		queryFn: () => {
			return apiClient.get<IEventSurveyResponse>(`survey/eventregistration/response/byToken?token=${accessToken}`);
		},
		queryKey: [GET_RESPONSE_BY_TOKEN_QUERY_KEY, accessToken],
		...(refetchInterval && { refetchInterval }),
		refetchOnWindowFocus,
		retry,
	});
};

export const invalidateGetEventRegistrationResponseByToken = () => {
	reactQueryClient.invalidateQueries({ queryKey: [GET_RESPONSE_BY_TOKEN_QUERY_KEY] });
};
